









import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class BoxTile extends Vue {
  @Prop({
    default: ''
  })
  public title!: string;

  @Prop({
    default: false
  })
  public tightPadding!: boolean;

}
